import { Store } from '@ngrx/store';
import { Component, OnInit } from '@angular/core';
import { LinksActions, LinksSelectors } from 'src/app/store';

@Component({
    selector: 'app-links',
    templateUrl: './links.component.html',
    styleUrls: ['./links.component.scss'],
})
export class LinksComponent implements OnInit {
    vm$ = this.store.select(LinksSelectors.selectLinksVM);

    constructor(private store: Store) { }

    ngOnInit() {
        this.store.dispatch(LinksActions.loadLinks());
    }
}
